import { Checkout, DeliveryZoneMs } from '../../types/generated';
import { apiMutate } from '../../utils/mutation';
import ServiceConfigs from '../../config';
import checkout from '../../mutations/checkout';

type useCheckoutType = ({
  branchId,
  cartId,
  isCartAuthorized,
}: {
  cartId: string;
  isCartAuthorized?: boolean;
  branchId: string;
}) => ({
  isScheduled,
  expectedAt,
  isGift,
  timeSlot,
  addressId,
  roundingAmount,
  paymentGatewayId,
  paymentMethodId,
  paymentType,
  paymentOption,
  paymentToken,
  isManualOrder,
  operatorId,
  deliveryZone,
  language,
}: {
  isScheduled: boolean;
  expectedAt?: string;
  isGift?: boolean;
  timeSlot?: string;
  addressId?: string;
  roundingAmount: number;
  paymentGatewayId?: string;
  paymentMethodId?: string;
  paymentType: string;
  paymentOption?: string;
  paymentToken?: string;
  isManualOrder?: boolean;
  operatorId?: string;
  deliveryZone?: DeliveryZoneMs;
  language: number;
}) => Promise<void | Partial<{ checkout: Checkout }> | { hasError: boolean }>;

const useCheckout: useCheckoutType =
  ({ cartId, isCartAuthorized, branchId }) =>
  variables =>
    apiMutate({
      mutation: checkout,
      variables:
        cartId && branchId && variables ? { ...variables, cartId, branchId, subdomain: ServiceConfigs.getSubDomain() } : null,
      requestHeaders: isCartAuthorized ? { ...ServiceConfigs.getAuthorizationHeader() } : {},
      handler: (response: any) => response?.checkout,
    }).then(response => {
      if (response !== undefined) {
        return response;
      }
      return { hasError: true };
    });

export default useCheckout;
